// rc-pagination: te_IN
const locale = {
  // core
  items_per_page: '/ పేజీకి అంశాలు',
  jump_to: 'కు వెళ్లండి',
  jump_to_confirm: 'ధృవీకరించు',
  page: 'పేజీ',

  // buttons
  prev_page: 'మునుపటి పేజీ',
  next_page: 'తదుపరి పేజీ',
  prev_5: 'మునుపటి 5 పేజీలు',
  next_5: 'తదుపరి 5 పేజీలు',
  prev_3: 'మునుపటి 3 పేజీలు',
  next_3: 'తదుపరి 3 పేజీలు',

  // size changer
  page_size: 'పేజీ పరిమాణం',
}
export default locale
